export const twDistricts =  [
    {
      "CityName": "臺北市",
      "AreaList": [
        {
          "ZipCode": "100",
          "AreaName": "中正區"
        },
        {
          "ZipCode": "103",
          "AreaName": "大同區"
        },
        {
          "ZipCode": "104",
          "AreaName": "中山區"
        },
        {
          "ZipCode": "105",
          "AreaName": "松山區"
        },
        {
          "ZipCode": "106",
          "AreaName": "大安區"
        },
        {
          "ZipCode": "108",
          "AreaName": "萬華區"
        },
        {
          "ZipCode": "110",
          "AreaName": "信義區"
        },
        {
          "ZipCode": "111",
          "AreaName": "士林區"
        },
        {
          "ZipCode": "112",
          "AreaName": "北投區"
        },
        {
          "ZipCode": "114",
          "AreaName": "內湖區"
        },
        {
          "ZipCode": "115",
          "AreaName": "南港區"
        },
        {
          "ZipCode": "116",
          "AreaName": "文山區"
        }
      ]
    },
    {
      "CityName": "基隆市",
      "AreaList": [
        {
          "ZipCode": "200",
          "AreaName": "仁愛區"
        },
        {
          "ZipCode": "201",
          "AreaName": "信義區"
        },
        {
          "ZipCode": "202",
          "AreaName": "中正區"
        },
        {
          "ZipCode": "203",
          "AreaName": "中山區"
        },
        {
          "ZipCode": "204",
          "AreaName": "安樂區"
        },
        {
          "ZipCode": "205",
          "AreaName": "暖暖區"
        },
        {
          "ZipCode": "206",
          "AreaName": "七堵區"
        }
      ]
    },
    {
      "CityName": "新北市",
      "AreaList": [
        {
          "ZipCode": "207",
          "AreaName": "萬里區"
        },
        {
          "ZipCode": "208",
          "AreaName": "金山區"
        },
        {
          "ZipCode": "220",
          "AreaName": "板橋區"
        },
        {
          "ZipCode": "221",
          "AreaName": "汐止區"
        },
        {
          "ZipCode": "222",
          "AreaName": "深坑區"
        },
        {
          "ZipCode": "223",
          "AreaName": "石碇區"
        },
        {
          "ZipCode": "224",
          "AreaName": "瑞芳區"
        },
        {
          "ZipCode": "226",
          "AreaName": "平溪區"
        },
        {
          "ZipCode": "227",
          "AreaName": "雙溪區"
        },
        {
          "ZipCode": "228",
          "AreaName": "貢寮區"
        },
        {
          "ZipCode": "231",
          "AreaName": "新店區"
        },
        {
          "ZipCode": "232",
          "AreaName": "坪林區"
        },
        {
          "ZipCode": "233",
          "AreaName": "烏來區"
        },
        {
          "ZipCode": "234",
          "AreaName": "永和區"
        },
        {
          "ZipCode": "235",
          "AreaName": "中和區"
        },
        {
          "ZipCode": "236",
          "AreaName": "土城區"
        },
        {
          "ZipCode": "237",
          "AreaName": "三峽區"
        },
        {
          "ZipCode": "238",
          "AreaName": "樹林區"
        },
        {
          "ZipCode": "239",
          "AreaName": "鶯歌區"
        },
        {
          "ZipCode": "241",
          "AreaName": "三重區"
        },
        {
          "ZipCode": "242",
          "AreaName": "新莊區"
        },
        {
          "ZipCode": "243",
          "AreaName": "泰山區"
        },
        {
          "ZipCode": "244",
          "AreaName": "林口區"
        },
        {
          "ZipCode": "247",
          "AreaName": "蘆洲區"
        },
        {
          "ZipCode": "248",
          "AreaName": "五股區"
        },
        {
          "ZipCode": "249",
          "AreaName": "八里區"
        },
        {
          "ZipCode": "251",
          "AreaName": "淡水區"
        },
        {
          "ZipCode": "252",
          "AreaName": "三芝區"
        },
        {
          "ZipCode": "253",
          "AreaName": "石門區"
        }
      ]
    },
    {
      "CityName": "宜蘭縣",
      "AreaList": [
        {
          "ZipCode": "260",
          "AreaName": "宜蘭市"
        },
        {
          "ZipCode": "263",
          "AreaName": "壯圍鄉"
        },
        {
          "ZipCode": "261",
          "AreaName": "頭城鎮"
        },
        {
          "ZipCode": "262",
          "AreaName": "礁溪鄉"
        },
        {
          "ZipCode": "264",
          "AreaName": "員山鄉"
        },
        {
          "ZipCode": "265",
          "AreaName": "羅東鎮"
        },
        {
          "ZipCode": "266",
          "AreaName": "三星鄉"
        },
        {
          "ZipCode": "267",
          "AreaName": "大同鄉"
        },
        {
          "ZipCode": "268",
          "AreaName": "五結鄉"
        },
        {
          "ZipCode": "269",
          "AreaName": "冬山鄉"
        },
        {
          "ZipCode": "270",
          "AreaName": "蘇澳鎮"
        },
        {
          "ZipCode": "272",
          "AreaName": "南澳鄉"
        },
        {
          "ZipCode": "290",
          "AreaName": "釣魚臺"
        }
      ]
    },
    {
      "CityName": "新竹市",
      "AreaList": [
        {
          "ZipCode": "300",
          "AreaName": "東區"
        },
        {
          "ZipCode": "300",
          "AreaName": "北區"
        },
        {
          "ZipCode": "300",
          "AreaName": "香山區"
        }
      ]
    },
    {
      "CityName": "新竹縣",
      "AreaList": [
        {
          "ZipCode": "308",
          "AreaName": "寶山鄉"
        },
        {
          "ZipCode": "302",
          "AreaName": "竹北市"
        },
        {
          "ZipCode": "303",
          "AreaName": "湖口鄉"
        },
        {
          "ZipCode": "304",
          "AreaName": "新豐鄉"
        },
        {
          "ZipCode": "305",
          "AreaName": "新埔鎮"
        },
        {
          "ZipCode": "306",
          "AreaName": "關西鎮"
        },
        {
          "ZipCode": "307",
          "AreaName": "芎林鄉"
        },
        {
          "ZipCode": "310",
          "AreaName": "竹東鎮"
        },
        {
          "ZipCode": "311",
          "AreaName": "五峰鄉"
        },
        {
          "ZipCode": "312",
          "AreaName": "橫山鄉"
        },
        {
          "ZipCode": "313",
          "AreaName": "尖石鄉"
        },
        {
          "ZipCode": "314",
          "AreaName": "北埔鄉"
        },
        {
          "ZipCode": "315",
          "AreaName": "峨眉鄉"
        }
      ]
    },
    {
      "CityName": "桃園市",
      "AreaList": [
        {
          "ZipCode": "320",
          "AreaName": "中壢區"
        },
        {
          "ZipCode": "324",
          "AreaName": "平鎮區"
        },
        {
          "ZipCode": "325",
          "AreaName": "龍潭區"
        },
        {
          "ZipCode": "326",
          "AreaName": "楊梅區"
        },
        {
          "ZipCode": "327",
          "AreaName": "新屋區"
        },
        {
          "ZipCode": "328",
          "AreaName": "觀音區"
        },
        {
          "ZipCode": "330",
          "AreaName": "桃園區"
        },
        {
          "ZipCode": "333",
          "AreaName": "龜山區"
        },
        {
          "ZipCode": "334",
          "AreaName": "八德區"
        },
        {
          "ZipCode": "335",
          "AreaName": "大溪區"
        },
        {
          "ZipCode": "336",
          "AreaName": "復興區"
        },
        {
          "ZipCode": "337",
          "AreaName": "大園區"
        },
        {
          "ZipCode": "338",
          "AreaName": "蘆竹區"
        }
      ]
    },
    {
      "CityName": "苗栗縣",
      "AreaList": [
        {
          "ZipCode": "350",
          "AreaName": "竹南鎮"
        },
        {
          "ZipCode": "351",
          "AreaName": "頭份市"
        },
        {
          "ZipCode": "352",
          "AreaName": "三灣鄉"
        },
        {
          "ZipCode": "353",
          "AreaName": "南庄鄉"
        },
        {
          "ZipCode": "354",
          "AreaName": "獅潭鄉"
        },
        {
          "ZipCode": "356",
          "AreaName": "後龍鎮"
        },
        {
          "ZipCode": "357",
          "AreaName": "通霄鎮"
        },
        {
          "ZipCode": "358",
          "AreaName": "苑裡鎮"
        },
        {
          "ZipCode": "360",
          "AreaName": "苗栗市"
        },
        {
          "ZipCode": "361",
          "AreaName": "造橋鄉"
        },
        {
          "ZipCode": "362",
          "AreaName": "頭屋鄉"
        },
        {
          "ZipCode": "363",
          "AreaName": "公館鄉"
        },
        {
          "ZipCode": "364",
          "AreaName": "大湖鄉"
        },
        {
          "ZipCode": "365",
          "AreaName": "泰安鄉"
        },
        {
          "ZipCode": "366",
          "AreaName": "銅鑼鄉"
        },
        {
          "ZipCode": "367",
          "AreaName": "三義鄉"
        },
        {
          "ZipCode": "368",
          "AreaName": "西湖鄉"
        },
        {
          "ZipCode": "369",
          "AreaName": "卓蘭鎮"
        }
      ]
    },
    {
      "CityName": "臺中市",
      "AreaList": [
        {
          "ZipCode": "400",
          "AreaName": "中區"
        },
        {
          "ZipCode": "401",
          "AreaName": "東區"
        },
        {
          "ZipCode": "402",
          "AreaName": "南區"
        },
        {
          "ZipCode": "403",
          "AreaName": "西區"
        },
        {
          "ZipCode": "404",
          "AreaName": "北區"
        },
        {
          "ZipCode": "406",
          "AreaName": "北屯區"
        },
        {
          "ZipCode": "407",
          "AreaName": "西屯區"
        },
        {
          "ZipCode": "408",
          "AreaName": "南屯區"
        },
        {
          "ZipCode": "411",
          "AreaName": "太平區"
        },
        {
          "ZipCode": "412",
          "AreaName": "大里區"
        },
        {
          "ZipCode": "413",
          "AreaName": "霧峰區"
        },
        {
          "ZipCode": "414",
          "AreaName": "烏日區"
        },
        {
          "ZipCode": "420",
          "AreaName": "豐原區"
        },
        {
          "ZipCode": "421",
          "AreaName": "后里區"
        },
        {
          "ZipCode": "422",
          "AreaName": "石岡區"
        },
        {
          "ZipCode": "423",
          "AreaName": "東勢區"
        },
        {
          "ZipCode": "424",
          "AreaName": "和平區"
        },
        {
          "ZipCode": "426",
          "AreaName": "新社區"
        },
        {
          "ZipCode": "427",
          "AreaName": "潭子區"
        },
        {
          "ZipCode": "428",
          "AreaName": "大雅區"
        },
        {
          "ZipCode": "429",
          "AreaName": "神岡區"
        },
        {
          "ZipCode": "432",
          "AreaName": "大肚區"
        },
        {
          "ZipCode": "433",
          "AreaName": "沙鹿區"
        },
        {
          "ZipCode": "434",
          "AreaName": "龍井區"
        },
        {
          "ZipCode": "435",
          "AreaName": "梧棲區"
        },
        {
          "ZipCode": "436",
          "AreaName": "清水區"
        },
        {
          "ZipCode": "437",
          "AreaName": "大甲區"
        },
        {
          "ZipCode": "438",
          "AreaName": "外埔區"
        },
        {
          "ZipCode": "439",
          "AreaName": "大安區"
        }
      ]
    },
    {
      "CityName": "彰化縣",
      "AreaList": [
        {
          "ZipCode": "500",
          "AreaName": "彰化市"
        },
        {
          "ZipCode": "502",
          "AreaName": "芬園鄉"
        },
        {
          "ZipCode": "503",
          "AreaName": "花壇鄉"
        },
        {
          "ZipCode": "504",
          "AreaName": "秀水鄉"
        },
        {
          "ZipCode": "505",
          "AreaName": "鹿港鎮"
        },
        {
          "ZipCode": "506",
          "AreaName": "福興鄉"
        },
        {
          "ZipCode": "507",
          "AreaName": "線西鄉"
        },
        {
          "ZipCode": "508",
          "AreaName": "和美鎮"
        },
        {
          "ZipCode": "509",
          "AreaName": "伸港鄉"
        },
        {
          "ZipCode": "510",
          "AreaName": "員林市"
        },
        {
          "ZipCode": "511",
          "AreaName": "社頭鄉"
        },
        {
          "ZipCode": "512",
          "AreaName": "永靖鄉"
        },
        {
          "ZipCode": "513",
          "AreaName": "埔心鄉"
        },
        {
          "ZipCode": "514",
          "AreaName": "溪湖鎮"
        },
        {
          "ZipCode": "515",
          "AreaName": "大村鄉"
        },
        {
          "ZipCode": "516",
          "AreaName": "埔鹽鄉"
        },
        {
          "ZipCode": "520",
          "AreaName": "田中鎮"
        },
        {
          "ZipCode": "521",
          "AreaName": "北斗鎮"
        },
        {
          "ZipCode": "522",
          "AreaName": "田尾鄉"
        },
        {
          "ZipCode": "523",
          "AreaName": "埤頭鄉"
        },
        {
          "ZipCode": "524",
          "AreaName": "溪州鄉"
        },
        {
          "ZipCode": "525",
          "AreaName": "竹塘鄉"
        },
        {
          "ZipCode": "526",
          "AreaName": "二林鎮"
        },
        {
          "ZipCode": "527",
          "AreaName": "大城鄉"
        },
        {
          "ZipCode": "528",
          "AreaName": "芳苑鄉"
        },
        {
          "ZipCode": "530",
          "AreaName": "二水鄉"
        }
      ]
    },
    {
      "CityName": "南投縣",
      "AreaList": [
        {
          "ZipCode": "540",
          "AreaName": "南投市"
        },
        {
          "ZipCode": "541",
          "AreaName": "中寮鄉"
        },
        {
          "ZipCode": "542",
          "AreaName": "草屯鎮"
        },
        {
          "ZipCode": "544",
          "AreaName": "國姓鄉"
        },
        {
          "ZipCode": "545",
          "AreaName": "埔里鎮"
        },
        {
          "ZipCode": "546",
          "AreaName": "仁愛鄉"
        },
        {
          "ZipCode": "551",
          "AreaName": "名間鄉"
        },
        {
          "ZipCode": "552",
          "AreaName": "集集鎮"
        },
        {
          "ZipCode": "553",
          "AreaName": "水里鄉"
        },
        {
          "ZipCode": "555",
          "AreaName": "魚池鄉"
        },
        {
          "ZipCode": "556",
          "AreaName": "信義鄉"
        },
        {
          "ZipCode": "557",
          "AreaName": "竹山鎮"
        },
        {
          "ZipCode": "558",
          "AreaName": "鹿谷鄉"
        }
      ]
    },
    {
      "CityName": "嘉義市",
      "AreaList": [
        {
          "ZipCode": "600",
          "AreaName": "西區"
        },
        {
          "ZipCode": "600",
          "AreaName": "東區"
        }
      ]
    },
    {
      "CityName": "嘉義縣",
      "AreaList": [
        {
          "ZipCode": "602",
          "AreaName": "番路鄉"
        },
        {
          "ZipCode": "603",
          "AreaName": "梅山鄉"
        },
        {
          "ZipCode": "604",
          "AreaName": "竹崎鄉"
        },
        {
          "ZipCode": "605",
          "AreaName": "阿里山鄉"
        },
        {
          "ZipCode": "606",
          "AreaName": "中埔鄉"
        },
        {
          "ZipCode": "607",
          "AreaName": "大埔鄉"
        },
        {
          "ZipCode": "608",
          "AreaName": "水上鄉"
        },
        {
          "ZipCode": "611",
          "AreaName": "鹿草鄉"
        },
        {
          "ZipCode": "612",
          "AreaName": "太保市"
        },
        {
          "ZipCode": "613",
          "AreaName": "朴子市"
        },
        {
          "ZipCode": "614",
          "AreaName": "東石鄉"
        },
        {
          "ZipCode": "615",
          "AreaName": "六腳鄉"
        },
        {
          "ZipCode": "616",
          "AreaName": "新港鄉"
        },
        {
          "ZipCode": "621",
          "AreaName": "民雄鄉"
        },
        {
          "ZipCode": "622",
          "AreaName": "大林鎮"
        },
        {
          "ZipCode": "623",
          "AreaName": "溪口鄉"
        },
        {
          "ZipCode": "624",
          "AreaName": "義竹鄉"
        },
        {
          "ZipCode": "625",
          "AreaName": "布袋鎮"
        }
      ]
    },
    {
      "CityName": "雲林縣",
      "AreaList": [
        {
          "ZipCode": "630",
          "AreaName": "斗南鎮"
        },
        {
          "ZipCode": "631",
          "AreaName": "大埤鄉"
        },
        {
          "ZipCode": "632",
          "AreaName": "虎尾鎮"
        },
        {
          "ZipCode": "633",
          "AreaName": "土庫鎮"
        },
        {
          "ZipCode": "634",
          "AreaName": "褒忠鄉"
        },
        {
          "ZipCode": "635",
          "AreaName": "東勢鄉"
        },
        {
          "ZipCode": "636",
          "AreaName": "臺西鄉"
        },
        {
          "ZipCode": "637",
          "AreaName": "崙背鄉"
        },
        {
          "ZipCode": "638",
          "AreaName": "麥寮鄉"
        },
        {
          "ZipCode": "640",
          "AreaName": "斗六市"
        },
        {
          "ZipCode": "643",
          "AreaName": "林內鄉"
        },
        {
          "ZipCode": "646",
          "AreaName": "古坑鄉"
        },
        {
          "ZipCode": "647",
          "AreaName": "莿桐鄉"
        },
        {
          "ZipCode": "648",
          "AreaName": "西螺鎮"
        },
        {
          "ZipCode": "649",
          "AreaName": "二崙鄉"
        },
        {
          "ZipCode": "651",
          "AreaName": "北港鎮"
        },
        {
          "ZipCode": "652",
          "AreaName": "水林鄉"
        },
        {
          "ZipCode": "653",
          "AreaName": "口湖鄉"
        },
        {
          "ZipCode": "654",
          "AreaName": "四湖鄉"
        },
        {
          "ZipCode": "655",
          "AreaName": "元長鄉"
        }
      ]
    },
    {
      "CityName": "臺南市",
      "AreaList": [
        {
          "ZipCode": "700",
          "AreaName": "中西區"
        },
        {
          "ZipCode": "701",
          "AreaName": "東區"
        },
        {
          "ZipCode": "702",
          "AreaName": "南區"
        },
        {
          "ZipCode": "704",
          "AreaName": "北區"
        },
        {
          "ZipCode": "708",
          "AreaName": "安平區"
        },
        {
          "ZipCode": "709",
          "AreaName": "安南區"
        },
        {
          "ZipCode": "710",
          "AreaName": "永康區"
        },
        {
          "ZipCode": "711",
          "AreaName": "歸仁區"
        },
        {
          "ZipCode": "712",
          "AreaName": "新化區"
        },
        {
          "ZipCode": "713",
          "AreaName": "左鎮區"
        },
        {
          "ZipCode": "714",
          "AreaName": "玉井區"
        },
        {
          "ZipCode": "715",
          "AreaName": "楠西區"
        },
        {
          "ZipCode": "716",
          "AreaName": "南化區"
        },
        {
          "ZipCode": "717",
          "AreaName": "仁德區"
        },
        {
          "ZipCode": "718",
          "AreaName": "關廟區"
        },
        {
          "ZipCode": "719",
          "AreaName": "龍崎區"
        },
        {
          "ZipCode": "720",
          "AreaName": "官田區"
        },
        {
          "ZipCode": "721",
          "AreaName": "麻豆區"
        },
        {
          "ZipCode": "722",
          "AreaName": "佳里區"
        },
        {
          "ZipCode": "723",
          "AreaName": "西港區"
        },
        {
          "ZipCode": "724",
          "AreaName": "七股區"
        },
        {
          "ZipCode": "725",
          "AreaName": "將軍區"
        },
        {
          "ZipCode": "726",
          "AreaName": "學甲區"
        },
        {
          "ZipCode": "727",
          "AreaName": "北門區"
        },
        {
          "ZipCode": "730",
          "AreaName": "新營區"
        },
        {
          "ZipCode": "731",
          "AreaName": "後壁區"
        },
        {
          "ZipCode": "732",
          "AreaName": "白河區"
        },
        {
          "ZipCode": "733",
          "AreaName": "東山區"
        },
        {
          "ZipCode": "734",
          "AreaName": "六甲區"
        },
        {
          "ZipCode": "735",
          "AreaName": "下營區"
        },
        {
          "ZipCode": "736",
          "AreaName": "柳營區"
        },
        {
          "ZipCode": "737",
          "AreaName": "鹽水區"
        },
        {
          "ZipCode": "741",
          "AreaName": "善化區"
        },
        {
          "ZipCode": "744",
          "AreaName": "新市區"
        },
        {
          "ZipCode": "742",
          "AreaName": "大內區"
        },
        {
          "ZipCode": "743",
          "AreaName": "山上區"
        },
        {
          "ZipCode": "745",
          "AreaName": "安定區"
        }
      ]
    },
    {
      "CityName": "高雄市",
      "AreaList": [
        {
          "ZipCode": "800",
          "AreaName": "新興區"
        },
        {
          "ZipCode": "801",
          "AreaName": "前金區"
        },
        {
          "ZipCode": "802",
          "AreaName": "苓雅區"
        },
        {
          "ZipCode": "803",
          "AreaName": "鹽埕區"
        },
        {
          "ZipCode": "804",
          "AreaName": "鼓山區"
        },
        {
          "ZipCode": "805",
          "AreaName": "旗津區"
        },
        {
          "ZipCode": "806",
          "AreaName": "前鎮區"
        },
        {
          "ZipCode": "807",
          "AreaName": "三民區"
        },
        {
          "ZipCode": "811",
          "AreaName": "楠梓區"
        },
        {
          "ZipCode": "812",
          "AreaName": "小港區"
        },
        {
          "ZipCode": "813",
          "AreaName": "左營區"
        },
        {
          "ZipCode": "814",
          "AreaName": "仁武區"
        },
        {
          "ZipCode": "815",
          "AreaName": "大社區"
        },
        {
          "ZipCode": "817",
          "AreaName": "東沙群島"
        },
        {
          "ZipCode": "819",
          "AreaName": "南沙群島"
        },
        {
          "ZipCode": "820",
          "AreaName": "岡山區"
        },
        {
          "ZipCode": "821",
          "AreaName": "路竹區"
        },
        {
          "ZipCode": "822",
          "AreaName": "阿蓮區"
        },
        {
          "ZipCode": "823",
          "AreaName": "田寮區"
        },
        {
          "ZipCode": "824",
          "AreaName": "燕巢區"
        },
        {
          "ZipCode": "825",
          "AreaName": "橋頭區"
        },
        {
          "ZipCode": "826",
          "AreaName": "梓官區"
        },
        {
          "ZipCode": "827",
          "AreaName": "彌陀區"
        },
        {
          "ZipCode": "828",
          "AreaName": "永安區"
        },
        {
          "ZipCode": "829",
          "AreaName": "湖內區"
        },
        {
          "ZipCode": "830",
          "AreaName": "鳳山區"
        },
        {
          "ZipCode": "831",
          "AreaName": "大寮區"
        },
        {
          "ZipCode": "832",
          "AreaName": "林園區"
        },
        {
          "ZipCode": "833",
          "AreaName": "鳥松區"
        },
        {
          "ZipCode": "840",
          "AreaName": "大樹區"
        },
        {
          "ZipCode": "842",
          "AreaName": "旗山區"
        },
        {
          "ZipCode": "843",
          "AreaName": "美濃區"
        },
        {
          "ZipCode": "844",
          "AreaName": "六龜區"
        },
        {
          "ZipCode": "845",
          "AreaName": "內門區"
        },
        {
          "ZipCode": "846",
          "AreaName": "杉林區"
        },
        {
          "ZipCode": "847",
          "AreaName": "甲仙區"
        },
        {
          "ZipCode": "848",
          "AreaName": "桃源區"
        },
        {
          "ZipCode": "849",
          "AreaName": "那瑪夏區"
        },
        {
          "ZipCode": "851",
          "AreaName": "茂林區"
        },
        {
          "ZipCode": "852",
          "AreaName": "茄萣區"
        }
      ]
    },
    {
      "CityName": "屏東縣",
      "AreaList": [
        {
          "ZipCode": "900",
          "AreaName": "屏東市"
        },
        {
          "ZipCode": "901",
          "AreaName": "三地門鄉"
        },
        {
          "ZipCode": "902",
          "AreaName": "霧臺鄉"
        },
        {
          "ZipCode": "903",
          "AreaName": "瑪家鄉"
        },
        {
          "ZipCode": "904",
          "AreaName": "九如鄉"
        },
        {
          "ZipCode": "905",
          "AreaName": "里港鄉"
        },
        {
          "ZipCode": "906",
          "AreaName": "高樹鄉"
        },
        {
          "ZipCode": "907",
          "AreaName": "鹽埔鄉"
        },
        {
          "ZipCode": "908",
          "AreaName": "長治鄉"
        },
        {
          "ZipCode": "909",
          "AreaName": "麟洛鄉"
        },
        {
          "ZipCode": "911",
          "AreaName": "竹田鄉"
        },
        {
          "ZipCode": "912",
          "AreaName": "內埔鄉"
        },
        {
          "ZipCode": "913",
          "AreaName": "萬丹鄉"
        },
        {
          "ZipCode": "920",
          "AreaName": "潮州鎮"
        },
        {
          "ZipCode": "921",
          "AreaName": "泰武鄉"
        },
        {
          "ZipCode": "922",
          "AreaName": "來義鄉"
        },
        {
          "ZipCode": "923",
          "AreaName": "萬巒鄉"
        },
        {
          "ZipCode": "924",
          "AreaName": "崁頂鄉"
        },
        {
          "ZipCode": "925",
          "AreaName": "新埤鄉"
        },
        {
          "ZipCode": "926",
          "AreaName": "南州鄉"
        },
        {
          "ZipCode": "927",
          "AreaName": "林邊鄉"
        },
        {
          "ZipCode": "928",
          "AreaName": "東港鎮"
        },
        {
          "ZipCode": "929",
          "AreaName": "琉球鄉"
        },
        {
          "ZipCode": "931",
          "AreaName": "佳冬鄉"
        },
        {
          "ZipCode": "932",
          "AreaName": "新園鄉"
        },
        {
          "ZipCode": "940",
          "AreaName": "枋寮鄉"
        },
        {
          "ZipCode": "941",
          "AreaName": "枋山鄉"
        },
        {
          "ZipCode": "942",
          "AreaName": "春日鄉"
        },
        {
          "ZipCode": "943",
          "AreaName": "獅子鄉"
        },
        {
          "ZipCode": "944",
          "AreaName": "車城鄉"
        },
        {
          "ZipCode": "945",
          "AreaName": "牡丹鄉"
        },
        {
          "ZipCode": "946",
          "AreaName": "恆春鎮"
        },
        {
          "ZipCode": "947",
          "AreaName": "滿州鄉"
        }
      ]
    },
    {
      "CityName": "臺東縣",
      "AreaList": [
        {
          "ZipCode": "950",
          "AreaName": "臺東市"
        },
        {
          "ZipCode": "951",
          "AreaName": "綠島鄉"
        },
        {
          "ZipCode": "952",
          "AreaName": "蘭嶼鄉"
        },
        {
          "ZipCode": "953",
          "AreaName": "延平鄉"
        },
        {
          "ZipCode": "954",
          "AreaName": "卑南鄉"
        },
        {
          "ZipCode": "955",
          "AreaName": "鹿野鄉"
        },
        {
          "ZipCode": "956",
          "AreaName": "關山鎮"
        },
        {
          "ZipCode": "957",
          "AreaName": "海端鄉"
        },
        {
          "ZipCode": "958",
          "AreaName": "池上鄉"
        },
        {
          "ZipCode": "959",
          "AreaName": "東河鄉"
        },
        {
          "ZipCode": "961",
          "AreaName": "成功鎮"
        },
        {
          "ZipCode": "962",
          "AreaName": "長濱鄉"
        },
        {
          "ZipCode": "963",
          "AreaName": "太麻里鄉"
        },
        {
          "ZipCode": "964",
          "AreaName": "金峰鄉"
        },
        {
          "ZipCode": "965",
          "AreaName": "大武鄉"
        },
        {
          "ZipCode": "966",
          "AreaName": "達仁鄉"
        }
      ]
    },
    {
      "CityName": "花蓮縣",
      "AreaList": [
        {
          "ZipCode": "970",
          "AreaName": "花蓮市"
        },
        {
          "ZipCode": "971",
          "AreaName": "新城鄉"
        },
        {
          "ZipCode": "972",
          "AreaName": "秀林鄉"
        },
        {
          "ZipCode": "973",
          "AreaName": "吉安鄉"
        },
        {
          "ZipCode": "974",
          "AreaName": "壽豐鄉"
        },
        {
          "ZipCode": "975",
          "AreaName": "鳳林鎮"
        },
        {
          "ZipCode": "976",
          "AreaName": "光復鄉"
        },
        {
          "ZipCode": "977",
          "AreaName": "豐濱鄉"
        },
        {
          "ZipCode": "978",
          "AreaName": "瑞穗鄉"
        },
        {
          "ZipCode": "979",
          "AreaName": "萬榮鄉"
        },
        {
          "ZipCode": "981",
          "AreaName": "玉里鎮"
        },
        {
          "ZipCode": "982",
          "AreaName": "卓溪鄉"
        },
        {
          "ZipCode": "983",
          "AreaName": "富里鄉"
        }
      ]
    }
  ]